import { FunctionComponent, useState } from 'react';
import { Card, Pagination } from '@shopify/polaris';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperClass from 'swiper/types/swiper-class';
import styled from 'styled-components';
import 'swiper/swiper.min.css';
import { CardTitleSmall } from '../common';

interface CarouselProps {
  title?: string;
  items: React.ReactNode[];
}

const ItemContainer = styled.div`
  max-width: 99%;
`;

const Carousel: FunctionComponent<CarouselProps> = (props) => {
  const [swiperInstance, setSwiperInstance] = useState<
    SwiperClass | undefined
  >();
  const { items, title } = props;

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleBackButtonClick = () =>
    swiperInstance && swiperInstance.slidePrev();
  const handleNextButtonClick = () =>
    swiperInstance && swiperInstance.slideNext();

  const handleSlideChange = (swiper: SwiperClass) => {
    setCurrentIndex(swiper.realIndex);
  };

  return (
    <Card title={<CardTitleSmall>{title}</CardTitleSmall>} sectioned>
      <Swiper
        onSwiper={(swiper) => setSwiperInstance(swiper)}
        onSlideChange={handleSlideChange}
        slidesPerView={1.25}
        spaceBetween={15}
      >
        {items.map((item, index) => (
          <SwiperSlide key={index}>
            <ItemContainer>{item}</ItemContainer>
          </SwiperSlide>
        ))}
      </Swiper>
      <Pagination
        onPrevious={handleBackButtonClick}
        onNext={handleNextButtonClick}
        hasNext={currentIndex + 1 !== items.length}
        hasPrevious={currentIndex !== 0}
      />
    </Card>
  );
};

export default Carousel;
